import { Component, OnInit } from '@angular/core';
import { CommonService } from '../../shared/services/common.service';
import { Router, ActivatedRoute } from '@angular/router';
import { APPCONFIG } from '../../config';
import { MdDialog, MdDialogRef } from '@angular/material';
import { TradeService } from '../trade.service'
import { ErrorHandler } from '../../shared/services/error-handler.service'
import { HttpService } from '../../shared/services/http.service'
import { LayoutService } from '../../layout/layout.service'
import { SessionHandler } from '../../shared/services/session-handler.service';
import { FormGroup, FormBuilder, FormControl, FormArray, Validators, NgControl } from '@angular/forms';
import * as $ from 'jquery';
import { deleteAddressComponent } from './deleteAddress.component';
import { dialogComponent } from '../../dialog/dialog.component';
import { addNewAddressComponent } from './addNewAddress.component';
import { addNewContactComponent } from './addNewContact.component';
import { countries } from '../../shared/coutry-data-store';
// import { TranslateService } from 'ng2-translate';
import { Http, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { Subscription } from 'rxjs';


@Component({
    selector: 'trade-detail',
    template: require('./details.component.html'),
    styles: [require('./details.component.scss'),require('../../style.scss')],
    providers: [HttpService, ErrorHandler, SessionHandler, TradeService]
})

export class TradeDetailsComponent {

    tradeDetailsForm: FormGroup;
    dialogRef;
    formData: any = {};
    tradeData: any;
    userData: any;
    addressList: any;
    addressResp: any;
    addressMsg: any;
    contactList: any;
    showNewAddress: boolean = false;
    street: any;
    postalCode: any;
    city: any;
    streetValid: boolean = false;
    postalCodeValid: boolean = false;
    cityValid: boolean = false;
    showNewContact: boolean = false;
    selectedAddress: any = null;
    selectedContactName: any = null;
    selectedContactEmail: any = null;
    selectedContactPhone: any = null;
    showCommonError: boolean = false;
    new_contact: any;
    showAddressEdit: boolean = false;
    tradePartnerId: any;
    istradePartnerId: boolean = false;
    isAdmin: boolean = false;
    enableButtons: boolean = false;
    isIcb: boolean = false;
    iscountryId: boolean;
    countryFromID: string ='';
    selectedCountry: string = '';
    public countries: any = countries;
    updateAddressData: any;
    cityFromID: String;
    streetFromID: String;
    zipCodeFromID: Number;
    country: string;
    addressSubscription: Subscription;

    constructor(private router: Router, private http: HttpService, private formBuilder: FormBuilder, private commonService: CommonService, private sessionHandler: SessionHandler,
        private dialog: MdDialog, private Http:Http) {
        if (this.http.checkSession()) {
            this.userData = JSON.parse(this.sessionHandler.getItem('loginData'));
            let icbCheck = JSON.parse(this.sessionHandler.getItem('isIcb'));
            if (icbCheck) {
                this.isIcb = true;
            } else {
                this.isIcb = false;
            }
            if (this.userData) {
                if (this.userData.role && this.userData.role.length > 0) {
                    if (this.userData.role.includes('ADMIN') || this.userData.role.includes('OTD_APPROVER') || this.userData.role.includes('END_CONSUMER')) {
                        this.isAdmin = true;
                    }
                    // *****OLD****
                    // for (let u in this.userData.role) {
                    //     if (this.userData.role[u] == 'ADMIN' || this.userData.role[u] == 'OTD_APPROVER' || this.userData.role[u] == 'END_CONSUMER') {
                    //         this.isAdmin = true;
                    //     }
                    // }
                }
                if (!this.isAdmin) {
                    this.enableButtons = true;
                    this.getTradeData();
                }
                this.commonService.addressChange.subscribe(() => {
                    this.getAddressList();
                });
                this.commonService.contactChange.subscribe(() => {
                    this.getContactList('new');
                });
            }
        } else {
            this.http.showSessionError();
        }
    }

    ngOnDestroy(){
        if(this.addressSubscription)
        this.addressSubscription.unsubscribe();     //clear subscription for address change
    }

    ngOnInit() {
        this.buildForm();
    }

    public tradePartnerIdEmptyheck() {
        this.resetTradeData();
        if (this.tradePartnerId != null && this.tradePartnerId != '') {
            this.istradePartnerId = true;
        }
    }

    public resetTradeData() {
        this.tradeDetailsForm.controls['addressId'].setValue(null);
        this.tradeDetailsForm.controls['countryId'].setValue(null);
        this.tradeDetailsForm.controls['contactNameId'].setValue(null);
        this.tradeDetailsForm.controls['contactEmailId'].setValue(null);
        this.tradeDetailsForm.controls['contactPhoneId'].setValue(null);
        this.tradeDetailsForm.controls['instructions'].setValue(null);
        this.addressList = [];
        this.contactList = [];
        this.enableButtons = false;
        this.showAddressEdit = false;
    }

    public getTradeData() {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        if (tradeId != null && tradeId != '') {
            this.http.getRequest('tradePartnerDetails/v1/get?tradePartnerId=' + tradeId)
                .subscribe(
                    res => {
                        this.saveTradeData(res)
                    },
                    err => {
                        this.tradePartnerId = null;
                        this.istradePartnerId = false;
                        if(err && err.status!=0){
                            this.dialogRef = this.dialog.open(dialogComponent);
                            this.dialogRef.componentInstance.msg = err;

                        }
                        this.http.onEnd();
                    });
        }
    }

    public saveTradeData(res) {
        if (res.status == "Success") {
            this.tradeData = res.tradePartner;
            if (this.isAdmin) {
                this.enableButtons = true;
            }
            this.getAddressList();
        } else {
            this.tradePartnerId = null;
            this.istradePartnerId = false;
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
            this.dialogRef.afterClosed().subscribe(result => {
                this.dialogRef = null;
            });
            this.http.onEnd();
        }
    }

    public getAddressList(action = null) {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        if(tradeId ==null || tradeId =='' ||tradeId==undefined){
            return
        }
        let data = {};
        data['tradePartnerId'] = tradeId;
        data['salesOrgId'] = APPCONFIG.salesOrgId;
        data['isICBUser'] = this.isIcb;
        this.http.postRequest(data, 'tradePartnerDetails/v1/invoiceBillingAddress')
            .subscribe(
                res => { this.saveAddressList(res, action) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }

    public getContactList(action = null) {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        this.http.getRequest('userOperationsApi/v1/getContacts?tradePartnerId=' + tradeId)
            .subscribe(
                res => { this.saveContactList(res, action) },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                });
    }


    public saveAddressList(res, action) {
        this.addressList = res.shippingAddressList;
        this.getContactList(action);
    }

    public saveContactList(res, action) {
        this.contactList = res.items;
        if (this.contactList && this.contactList.length > 0) {
            if (action != 'saved') {
                this.setDefaultInfo();
            }
            if (action == 'new') {
                this.selectedContactName = this.contactList[this.contactList.length - 1].id;
                this.selectedContactEmail = this.contactList[this.contactList.length - 1].id;
                this.selectedContactPhone = this.contactList[this.contactList.length - 1].id;
            }
        }
        // this.customSelect();
        this.http.onEnd();
    }

    public buildForm() {
        this.tradeDetailsForm = this.formBuilder.group({
            addressId: this.formBuilder.control(null, [Validators.required]),
            countryId: this.formBuilder.control(null, [Validators.required]),
            contactNameId: this.formBuilder.control(null, [Validators.required]),
            contactEmailId: this.formBuilder.control(null, [Validators.required]),
            contactPhoneId: this.formBuilder.control(null, [Validators.required]),
            instructions: this.formBuilder.control(null, [])
        });
        this.tradeDetailsForm.controls['countryId'].disable();
    }


    public checkDropDown(field: string) {
        if (field == 'address') {
            if (this.addressList && Object.keys(this.addressList).length < 1) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'no_address_added_yet';
            }
        }
        if (field == 'contact') {
            if (this.contactList && Object.keys(this.contactList).length < 1) {
                this.dialogRef = this.dialog.open(dialogComponent);
                this.dialogRef.componentInstance.msg = 'no_contact_added_yet';
                // alert('No contact has been added yet, Click on "Add New Contact" button to add contact information.');
            }
        }
    }

    public saveNewAddress() {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewAddressComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
    }

    public addressResponse(res) {
        if (res.status != 'Failed') {
            this.selectedAddress = res.id;
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Address added successfully.';
            this.getAddressList('saved');
        } else {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
        this.http.onEnd();
    }


    public saveNewContact() {
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef = this.dialog.open(addNewContactComponent);
        this.dialogRef.componentInstance.tradeId = tradeId;
        //this.getAddressList('saved');
    }

    public setDefaultInfo() {

        if (this.tradeData) {
            if (this.tradeData.contactName) {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactName == this.tradeData.contactName) {
                        this.selectedContactName = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactEmail) {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactEmail == this.tradeData.contactEmail) {
                        this.selectedContactEmail = this.contactList[i].id;
                    }
                }
            }
            if (this.tradeData.contactPhone) {
                for (let i in this.contactList) {
                    if (this.contactList[i].contactPhone == this.tradeData.contactPhone) {
                        this.selectedContactPhone = this.contactList[i].id;
                    }
                }
            }
            let check = false;
            if (this.tradeData.addressId) {
                if (this.addressList) {
                    for (let i in this.addressList) {
                        if (this.addressList[i].id == this.tradeData.addressId) {
                            this.selectedAddress = this.tradeData.addressId;
                            this.onChange(this.selectedAddress)
                            if(this.tradeData.country){
                                this.tradeDetailsForm.controls['countryId'].disable();
                            }
                            check = true;
                        }
                    }
                    if (!check) {
                        this.tradeDetailsForm.controls['addressId'].setValue(null);
                        this.tradeDetailsForm.controls['countryId'].setValue(null);
                    }
                }
            }
            if (this.tradeData.instructions) {
                this.tradeDetailsForm.controls['instructions'].setValue(this.tradeData.instructions);
            } else {
                this.tradeDetailsForm.controls['instructions'].setValue(null);
            }
        }
        this.addressSubscription = this.commonService.addressSourceObs.subscribe(res=>{         //subscribe to addressChange and check if different address ids
            if (res !== this.selectedAddress && this.addressList) {
                for (let i in this.addressList) {
                    if (this.addressList[i].id == res) {                                           //set new address and country
                        this.selectedAddress = res;
                        this.onChange(res);
                        // this.dialogRef = this.dialog.open(dialogComponent);
                        // this.dialogRef.componentInstance.msg = 'New address will be reflected.';  
                    }
                }
            }
        });
    }
    public setFormDetails() {
        if (this.addressList) {
            for (let i in this.addressList) {
                if (this.addressList[i].id == this.formData.trade_details.addressId) {
                    this.formData['trade_details'].address = this.addressList[i].address;
                }
            }
        }
        if (this.contactList) {
            for (let i in this.contactList) {
                if (this.contactList[i].id == this.formData.trade_details.contactNameId) {
                    this.formData['trade_details'].contactName = this.contactList[i].contactName;
                }
                if (this.contactList[i].id == this.formData.trade_details.contactEmailId) {
                    this.formData['trade_details'].contactEmail = this.contactList[i].contactEmail;
                }
                if (this.contactList[i].id == this.formData.trade_details.contactPhoneId) {
                    this.formData['trade_details'].contactPhone = this.contactList[i].contactPhone;
                }
            }
        }
        return true;
    }

    public editDetails(table) {
        this.dialogRef = this.dialog.open(deleteAddressComponent, { disableClose: true });
        let dialogData = {};
        if (table == 'address') {
            dialogData['table'] = table;
            dialogData['data'] = this.addressList;
        }
        this.dialogRef.componentInstance.rowData = dialogData;
        this.dialogRef.componentInstance.isAdmin = this.isAdmin;
        this.dialogRef.componentInstance.invoiceAddress = this.tradeData.billingAddress;
        let tradeId;
        if (this.isAdmin) {
            tradeId = this.tradePartnerId;
        } else {
            tradeId = this.userData.tradePartnerId;
        }
        this.dialogRef.componentInstance.tradePartnerId = tradeId;
    }

    public tradeDetailSave() {
        this.formData['trade_details'] = this.tradeDetailsForm.getRawValue();
        if (this.setFormDetails()) {
            // if(this.tradeData) {
            //     this.formData['trade_details'].billingAddress = this.tradeData.billingAddress;
            //     this.formData['trade_details'].name1 = this.tradeData.name1; 
            //     this.formData['trade_details'].name2 = this.tradeData.name2;
            // }
            if (this.isAdmin) {
                this.formData['trade_details'].tradePartnerId = this.tradePartnerId;
            } else {
                this.formData['trade_details'].tradePartnerId = this.userData.tradePartnerId;
            }
            this.http.postRequest(this.formData.trade_details, 'tradePartnerDetails/v1/update').subscribe(
                res => {
                    this.saveResponse(res);
                },
                err => {
                    if(err && err.status!=0){
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = err;

                    }
                    this.http.onEnd();
                }
            );
        }
    }

    public saveResponse(res) {
        this.http.onEnd();
        if (res.status == 'Success') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = 'Trade details saved successfully';
            // this.dialogRef.afterClosed().subscribe(result => {
            //     if (result) {
            //         if (this.isIcb) {
            //             this.router.navigateByUrl('/app/icb/dashboard');
            //         } else {
            //             this.router.navigateByUrl('/app/dashboard');
            //         }

            //     }
            //     this.dialogRef = null;
            // });
        }
        if (res.status == 'Error') {
            this.dialogRef = this.dialog.open(dialogComponent);
            this.dialogRef.componentInstance.msg = res.errorMessage;
        }
    }

    public addElement(parentId, elementTag, elementId, html) {
        // Adds an element to the document
        var p = document.getElementById(parentId);
        var newElement = document.createElement(elementTag);
        newElement.setAttribute('id', elementId);
        newElement.innerHTML = html;
        p.appendChild(newElement);
    }

    public removeElement(elementId) {
        // Removes an element from the document
        var element = document.getElementById(elementId);
        while (element.firstChild) {
            element.removeChild(element.firstChild);
        }
        // element.parentNode.removeChild(element);

        this.addElement('address-select', 'select', 'group',
            '<option *ngFor="let list of addressList; let i =index" [value]="list.id">{{list.address}}</option>');
    }

    public customSelect() {
        var x, i, j, selElmnt, a, b, c;
        this.removeElement('address-select');
        /*look for any elements with the class "custom-select":*/
        x = document.getElementsByClassName("address-select");
        console.log(x);
        for (i = 0; i < x.length; i++) {
            selElmnt = x[i].getElementsByTagName("select")[0];
            /*for each element, create a new DIV that will act as the selected item:*/
            a = document.createElement("DIV");
            a.setAttribute("class", "select-selected");
            a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
            x[i].appendChild(a);
            /*for each element, create a new DIV that will contain the option list:*/
            b = document.createElement("DIV");
            b.setAttribute("class", "select-items select-hide");
            for (j = 0; j < selElmnt.length; j++) {
                /*for each option in the original select element,
                create a new DIV that will act as an option item:*/
                c = document.createElement("DIV");
                c.innerHTML = selElmnt.options[j].innerHTML;
                c.addEventListener("click", function (e) {
                    /*when an item is clicked, update the original select box,
                    and the selected item:*/
                    var y, i, k, s, h;
                    s = this.parentNode.parentNode.getElementsByTagName("select")[0];
                    h = this.parentNode.previousSibling;
                    for (i = 0; i < s.length; i++) {
                        if (s.options[i].innerHTML == this.innerHTML) {
                            s.selectedIndex = i;
                            h.innerHTML = this.innerHTML;
                            y = this.parentNode.getElementsByClassName("same-as-selected");
                            for (k = 0; k < y.length; k++) {
                                y[k].removeAttribute("class");
                            }
                            this.setAttribute("class", "same-as-selected");
                            break;
                        }
                    }
                    h.click();
                });
                b.appendChild(c);
            }
            x[i].appendChild(b);
            a.addEventListener("click", function (e) {
                /*when the select box is clicked, close any other select boxes,
                and open/close the current select box:*/
                e.stopPropagation();
                closeAllSelect(this);
                this.nextSibling.classList.toggle("select-hide");
                this.classList.toggle("select-arrow-active");
            });
        }
        function closeAllSelect(elmnt) {
            /*a function that will close all select boxes in the document,
            except the current select box:*/
            var x, y, i, arrNo = [];
            x = document.getElementsByClassName("select-items");
            y = document.getElementsByClassName("select-selected");
            for (i = 0; i < y.length; i++) {
                if (elmnt == y[i]) {
                    arrNo.push(i)
                } else {
                    y[i].classList.remove("select-arrow-active");
                }
            }
            for (i = 0; i < x.length; i++) {
                if (arrNo.indexOf(i)) {
                    x[i].classList.add("select-hide");
                }
            }
        }
        /*if the user clicks anywhere outside the select box,
        then close all select boxes:*/
        document.addEventListener("click", closeAllSelect);
    }

    public cancel() {
        if (this.isIcb) {
            this.router.navigateByUrl('/app/icb/dashboard');
        } else {
            this.router.navigateByUrl('/app/dashboard');
        }
    }

    public onChange(data) {                                     //function to select country on address change
        try {
            this.iscountryId = true;
            if (data)                                           //check address id and current selected id(data)
                this.addressList.forEach(ele => {
                    if (Number(data) === Number(ele.id)) {
                        ele.country.length > 0 ? this.countryFromID = ele.country : this.countryFromID = '';
                        ele.city.length > 0 ? this.cityFromID = ele.city : this.cityFromID = '';
                        ele.street.length > 0 ? this.streetFromID = ele.street : this.cityFromID = '';
                        ele.zipCode.length > 0 ? this.zipCodeFromID = ele.zipCode : this.zipCodeFromID = 0;
                    }
                    else this.selectedCountry = '';
                });

            if (this.countryFromID !== '') {                      //if ids match find country using country code, disable and validate
                this.countries.forEach(country => {
                    if (this.countryFromID.toUpperCase() === country.code.toUpperCase()) {
                        this.selectedCountry = country.code;
                        this.tradeDetailsForm.get('countryId').disable();
                        this.tradeDetailsForm.get('countryId').setValidators(Validators.required);
                        this.tradeDetailsForm.get('countryId').updateValueAndValidity();
                    }
                });
            }
            else this.selectedCountry = '';

            if (this.selectedCountry === '' || this.countryFromID === '') { //else reset, validate and enable country drop down
                this.tradeDetailsForm.get('countryId').enable();
                this.tradeDetailsForm.get('countryId').reset();
                this.tradeDetailsForm.get('countryId').setValidators(Validators.required);
                this.tradeDetailsForm.get('countryId').updateValueAndValidity();
            }
        } catch (error) {
            console.log('exception occured', error);
        }

    }

    public updateAddress() {                    //API function call to update address in the backend
        try {
            let headers = new Headers({
                'Content-Type': 'application/json',
                apiKey: 'AIzaSyDYlzt8e-7tSUzzDS802X_4RgQMmx0N79Y',
                'access-token': this.sessionHandler.getItem('token')
            });
            let options = new RequestOptions({ headers: headers, responseType: ResponseContentType.Json });

            this.updateAddressData={};             // Request body
            this.updateAddressData.tradePartnerId = this.tradePartnerId;
            this.updateAddressData.city = this.cityFromID;
            this.updateAddressData.zipCode = this.zipCodeFromID;
            this.updateAddressData.street = this.streetFromID;
            this.updateAddressData.country = this.selectedCountry;
            this.updateAddressData.id = this.selectedAddress;

            this.http.showLoader();
            this.Http.post(APPCONFIG.appUrlBase + '/_ah/api/address/v1/updateAddress', this.updateAddressData, options).subscribe(
                res => {
                    if (res.status == 200) {
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Updated Country Successfully';
                    }
                    else{
                        this.dialogRef = this.dialog.open(dialogComponent);
                        this.dialogRef.componentInstance.msg = 'Update Failed';
                    }
                    this.http.onEnd();
                },
            );
        } catch (error) {

        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/trade/details/details.component.ts